import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { getParentHierarchy } from 'src/@smartmanufacturing/common/custom_methods';
import { Multilingual } from 'src/app/services/multilingual';
import { TranslaterService } from 'src/app/services/translater.service';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {

  breadcrumList: any[] = [];
  menus: any[] = [];
  currentMenuId: string = '';
  langObj: any;
  pageId: string;
  moduleId: any;
  // translate: any;
  // translater: any;
  ParameterTypeGripApi: any;
  HeaderGripApi: any;
  lang: Multilingual;
  languageDir: string;
  constructor(private baseApi: BaseApi, public router: Router, public translate: TranslateService, public translater: TranslaterService,) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
  }

  ngOnInit() {
    this.menus = this.baseApi.getMenuCardsSession();
    this.currentMenuId = this.baseApi.getCurrentMenuID();
    this.getBreadcrumList();

  }
  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : this.translate.currentLang === 'gr'
                  ? 5
                  : this.translate.currentLang === 'du'
                    ? 6
                    : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        if (this.hasRealTranslation(elem.tagName, elem.translatedValue)) {
          obj[elem.tagName] = elem.translatedValue;
        }
      });
      this.langObj = obj;
      this.lang = new Multilingual(this.translater, this.translate);
      this.lang.getLangWords();
    });
  }


  getBreadcrumList(): any {
    const menusForBreadCrumbs = getParentHierarchy(this.menus, this.currentMenuId)
    this.breadcrumList = [...menusForBreadCrumbs];
    this.getLangWords();
  }



  displayRightmenu(menuId: string, url: any, type: string): any {
    this.baseApi.saveCurrentMenuID(menuId);
    switch (type) {
      case 'subheading':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'dropdown':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'link':
        if (url.indexOf('/Home/ExternalLink?link=') > -1) {
          url = url.replace('/Home/ExternalLink?link=', '');
          window.open(url, '_blank');
        }
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate([url]));
        break;
      default:
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
    }
  }


  // Breadcrumb labels are menu names coming from the DB menu tree. Resolve each one
  // through the page tags first, then assets/i18n/<active language>.json (verbatim and
  // as a tag), and fall back to the original label. Never returns an empty string —
  // the previous binding rendered blank crumbs whenever a tag was missing.
  public translateLabel(label: string): string {
    if (!label) {
      return '';
    }
    const candidates = [label, this.toTag(label)].filter((key) => !!key);
    if (this.langObj) {
      for (const key of candidates) {
        if (this.langObj[key]) {
          return this.langObj[key];
        }
      }
      const normalized = this.toTag(label).toLowerCase();
      const match = Object.keys(this.langObj).find((k) => this.toTag(k).toLowerCase() === normalized);
      if (match) {
        return this.langObj[match];
      }
    }
    for (const key of candidates) {
      const translated = this.translate ? this.translate.instant(key) : key;
      if (translated && translated !== key) {
        return translated;
      }
    }
    return label;
  }

  private toTag(text: string): string {
    return (text || '')
      .split(/[^A-Za-z0-9]+/)
      .filter((word) => !!word)
      .map((word) => (word === word.toUpperCase() ? word : word.charAt(0).toUpperCase() + word.slice(1)))
      .join('');
  }

  // A tag configured in the Language screen but never given a value for the current
  // language comes back empty or still holding the English text.
  private hasRealTranslation(tagName: string, value: string): boolean {
    if (!value || !value.trim()) {
      return false;
    }
    const lang = this.translate ? this.translate.currentLang : 'en';
    if (!lang || lang === 'en') {
      return true;
    }
    if (lang === 'ar') {
      return /[\u0600-\u06FF]/.test(value);
    }
    return this.toTag(value).toLowerCase() !== this.toTag(tagName).toLowerCase();
  }
}
